export default __webpack_public_path__ + "static/media/Blog8.04586647.png";